export const META_LABEL =
  "mobile-pref-card-meta text-lg font-black uppercase tracking-widest text-mono-500 dark:text-mono-400";

export const LOUD_CHIP =
  "mobile-pref-chip inline-flex h-11 flex-none items-center rounded-full px-4 text-base font-black shadow-pill text-white text-shadow-on-color-strong";

const TAG_TONES = [
  "bg-tile-calendar",
  "bg-tile-people",
  "bg-tile-achievement",
  "bg-tile-media",
  "bg-tile-schedule",
  "bg-tile-info",
  "bg-tile-energy"
] as const;

export const tagTone = (tag: string): string => {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) hash = (hash + tag.charCodeAt(i)) | 0;
  return TAG_TONES[Math.abs(hash) % TAG_TONES.length];
};
